
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.29 5.006V3.521h1.082V0H3v3.521h1.081v1.485a6.603 6.603 0 003.265 5.688 6.603 6.603 0 00-3.265 5.689v1.485H3v3.52h15.372v-3.52H17.29v-1.485a6.603 6.603 0 00-3.265-5.689 6.603 6.603 0 003.265-5.688m-1.834 11.377v1.485H5.915v-1.485c0-2.631 2.141-4.772 4.772-4.772 2.63 0 4.771 2.14 4.771 4.772m-4.771-6.605a4.777 4.777 0 01-4.772-4.772V3.521h9.543v1.485c0 2.631-2.14 4.772-4.771 4.772","fill":"#8E8E92","fill-rule":"evenodd"}})])
          )
        }
      }
    